<!--
 * @Descripttion: apis设计器
 * @Author: zenghua.wang
 * @Date: 2021-06-28 10:47:14
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-03-28 17:58:08
-->
<template>
  <el-card
    class="apis-container"
    v-loading="loading"
  >
    <header class="apis-header">
      <el-tooltip
        effect="dark"
        :content="item.title"
        v-for="(item, index) in buttons"
        :key="index"
        placement="bottom"
      >
        <span class="apis-header-item">
          <el-button
            v-if="item.name == 'save'"
            type="text"
            :loading="saveLoading"
            @click="getMethod(item.evt)"
          ><img :src="item.icon" /></el-button>
          <el-button
            v-else
            type="text"
            @click="getMethod(item.evt)"
          ><img :src="item.icon" /></el-button>
        </span>
      </el-tooltip>
    </header>

    <div class="apis-main">
      <el-aside
        class="apis-menu"
        width="100px"
        ref="shapeBar"
      >
        <template v-for="(item, index) in shapes">
          <div
            class="apis-menu-item"
            v-show="!item.hidden"
            :key="index"
            ref="shapeItem"
          >
            <i class="icon"> <img
                :src="item.icon"
                :id="item.value"
              /></i>
            <span>{{ item.title }}</span>
          </div>
        </template>
      </el-aside>
      <main
        class="apis-main-canvas"
        ref="apisCanvas"
      ></main>
    </div>

    <footer class="apis-footer">
      <el-tabs v-model="active">
        <el-tab-pane
          label="基础信息"
          name="tab-1"
        >
          <el-form
            label-suffix="："
            labelPosition="left"
            labelWidth="100px"
            size="small"
          >
            <div class="apis-row">
              <el-form-item
                label="名称"
                class="apis-row-item"
                style="margin-right: 40px"
                required
              >
                <el-input
                  style="width: 100%"
                  clearable
                  placeholder="请输入"
                  v-model="data.apisMainConfig.name"
                >
                </el-input>
              </el-form-item>
              <el-form-item
                label="分类"
                class="apis-row-item"
                style="margin-right: 40px"
                required
              >
                <el-select
                  style="width: 100%"
                  size="small"
                  clearable
                  placeholder="请选择"
                  v-model="data.apisMainConfig.serveClass"
                >
                  <el-option
                    v-for="(item, index) in apisConstList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="请求方式"
                class="apis-row-item"
                required
              >
                <el-select
                  style="width: 100%"
                  size="small"
                  clearable
                  placeholder="请选择"
                  v-model="data.apisMainConfig.reqMethod"
                >
                  <el-option
                    label="GET"
                    value="GET"
                  ></el-option>
                  <el-option
                    label="POST"
                    value="POST"
                  ></el-option>
                  <!-- <el-option
                    label="PUT"
                    value="PUT"
                  ></el-option>
                  <el-option
                    label="DELETE"
                    value="DELETE"
                  ></el-option> -->
                </el-select>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="所属应用">
                <el-select
                  style="width: 50%"
                  size="small"
                  clearable
                  placeholder="请选择"
                  v-model="data.apisMainConfig.appId"
                >
                  <el-option
                    v-for="(item, index) in appList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="备注">
                <el-input
                  type="textarea"
                  style="width: 100%"
                  clearable
                  rows="4"
                  placeholder="请输入"
                  v-model="data.apisMainConfig.remark"
                >
                </el-input>
              </el-form-item>
            </div>
          </el-form>
        </el-tab-pane>

        <el-tab-pane
          label="查询参数"
          name="tab-2"
        >
          <apis-config
            :id="id"
            :tenantId="tenantId"
            title="参数名"
            type="query"
            :column="paramList"
            @change="onUpdateList"
          />
        </el-tab-pane>

        <el-tab-pane
          label="Body参数"
          name="tab-3"
        >
          <apis-config
            :id="id"
            :tenantId="tenantId"
            title="参数名"
            type="body"
            :column="bodyList"
            @change="onUpdateList"
          />
        </el-tab-pane>

        <el-tab-pane
          label="全局Cookie"
          name="tab-4"
        >
          <apis-config
            :id="id"
            :tenantId="tenantId"
            title="cookie名称"
            type="cookie"
            :column="cookieList"
            @change="onUpdateList"
          />
        </el-tab-pane>

        <el-tab-pane
          label="全局Header"
          name="tab-5"
        >
          <apis-config
            :id="id"
            :tenantId="tenantId"
            title="参数名"
            type="header"
            :column="headerList"
            @change="onUpdateList"
          />
        </el-tab-pane>
      </el-tabs>
    </footer>

    <!-- 显示xml -->
    <el-dialog
      :title="dialog.title"
      :visible.sync="dialog.showXML"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      append-to-body
      width="50%"
    >
      <el-input
        class="apis-dialog-xml"
        type="textarea"
        :autosize="{ minRows: 16 }"
        placeholder="请输入符合mxGraph规范的xml"
        resize="none"
        v-model="dialog.xml"
      />
      <span slot="footer">
        <el-button @click="dialog.showXML = false">取 消</el-button>
        <el-button
          type="primary"
          @click="importXML"
        >{{dialog.action==='import' ? '导 入' : '切 换'}}</el-button>
      </span>
    </el-dialog>

    <!-- table -->
    <apis-table
      :show.sync="dialog.table"
      :tenantId="tenantId"
      :globalParamList="paramList"
      :data="tableItem"
      @change="onUpdateData"
    />
    <!-- rest -->
    <apis-rest
      :show.sync="dialog.http"
      :tenantId="tenantId"
      :paramList="data.apisMainConfigReqCtls"
      :data="httpItem"
      @change="onUpdateData"
    />
    <!-- const -->
    <apis-const
      :show.sync="dialog.constant"
      :tenantId="tenantId"
      :data="constantItem"
      @change="onUpdateData"
    />
    <!-- data -->
    <apis-data-process
      :show.sync="dialog.data"
      :tenantId="tenantId"
      :data="dataProcessItem"
      @change="onUpdateData"
    />
    <!-- output -->
    <apis-output
      v-if="data.apisMainOutCtlsModels"
      :show.sync="dialog.respons"
      :tenantId="tenantId"
      :data="data.apisMainOutCtlsModels"
      @change="onUpdateData"
    />
  </el-card>
</template>
<script>
import { ApisEditor } from '@/apisManage/mxgraph/editor'
import { shapes } from '@/apisManage/mxgraph/shapes'
import { buttons } from '@/apisManage/mxgraph/button'
import {
  isEmpty,
  createId,
  getArrayByType,
  getArrayByConcat
} from '@/apisManage/utils'
import main from '@/apisManage/mixins/main.js'
import apisTable from '@/apisManage/components/table'
import apisRest from '@/apisManage/components/rest'
import apisConst from '@/apisManage/components/const'
import apisDataProcess from '@/apisManage/components/dataProcess'
import apisOutput from '@/apisManage/components/output'
import apisConfig from './fragment/config'
export default {
  name: 'ApisDesign',
  mixins: [main],
  components: {
    apisTable,
    apisRest,
    apisConst,
    apisDataProcess,
    apisOutput,
    apisConfig
  },
  data() {
    return {
      loading: false,
      saveLoading: false,
      id: '',
      appId: '',
      microOpen: 'false',
      tenantId: null,
      data: {
        apisMainConfig: {
          name: '',
          serveClass: '1',
          reqMethod: 'GET'
        },
        apisMainConfigReqCtls: [],
        apisLineCtls: [],
        apisTbCtlsModels: [],
        apisHttpCtlsModels: [],
        apisConstantCvsCtlsModels: [],
        apisDataProcessingCtlsModels: [],
        apisMainOutCtlsModels: {
          apisMainOutCtls: {},
          apisMainOutCtlsDataList: []
        }
      },
      // mxgraph
      editor: null,
      shapes: shapes,
      buttons: buttons,
      dialog: {
        table: false,
        http: false,
        constant: false,
        data: false,
        respons: false,
        title: '',
        action: 'import',
        xml: '',
        showXML: false
      },
      tableItem: {
        apisTbCtls: {},
        apisTbCtlsCorrelationList: [],
        apisTbCtlsReqParamList: [],
        apisTbCtlsReqParamConditionsModelList: [],
        apisTbCtlsReturnList: []
      },
      httpItem: {
        apisHttpCtls: {},
        apisHttpCtlsReqParamList: []
      },
      constantItem: {
        apisConstantCvsCtls: {},
        apisConstantCvsCtlsDataList: []
      },
      dataProcessItem: {
        apisDataProcessingCtls: {},
        apisDataProcessingCtlsDetailList: []
      },
      // tabs
      active: 'tab-1',
      paramList: [],
      bodyList: [],
      cookieList: [],
      headerList: []
    }
  },
  methods: {
    loadData() {
      this.id = this.$route.query.id ? this.$route.query.id : null
      this.appId = this.$route.query.appId || ''
      this.microOpen = this.$route.query.microOpen || 'false'
      if (isEmpty(this.id)) {
        this.initDefault()
        return
      } else {
        this.loading = true
        this.$http
          .get(`/apis/main-config/${this.id}`)
          .then((res) => {
            if (res.code === 200) {
              if (isEmpty(res.data.apisMainConfig)) {
                this.loading = false
                return
              }
              this.data = res.data
              this.initData()
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            this.$message.error(err.msg)
          })
      }
    },
    initDefault() {
      // 处理后台添加数据不规范，导致前台页面报错问题
      if (isEmpty(this.data.apisTbCtlsModels)) {
        this.data.apisTbCtlsModels = []
      }
      // rest
      if (isEmpty(this.data.apisHttpCtlsModels)) {
        this.data.apisHttpCtlsModels = []
      }

      // const
      if (isEmpty(this.data.apisConstantCvsCtlsModels)) {
        this.data.apisConstantCvsCtlsModels = []
      }

      // data
      if (isEmpty(this.data.apisDataProcessingCtlsModels)) {
        this.data.apisDataProcessingCtlsModels = []
      }

      // output
      if (isEmpty(this.data.apisMainOutCtlsModels)) {
        this.data.apisMainOutCtlsModels = {
          apisMainOutCtls: {},
          apisMainOutCtlsDataList: []
        }
      }
      // console.log('initData this.data==', this.data)
    },
    initData() {
      // 分割出参数、body、cookie、header
      this.tenantId = this.data.apisMainConfig.tenantId
      this.paramList = getArrayByType(this.data.apisMainConfigReqCtls, 'query')
      this.bodyList = getArrayByType(this.data.apisMainConfigReqCtls, 'body')
      this.cookieList = getArrayByType(
        this.data.apisMainConfigReqCtls,
        'cookie'
      )
      this.headerList = getArrayByType(
        this.data.apisMainConfigReqCtls,
        'header'
      )
      // 初始化xml
      if (this.editor) {
        this.editor.setXML(this.data.apisMainConfig.xml)
      }
      this.initDefault()
    },
    init() {
      let self = this
      let dom = this.$refs.apisCanvas
      if (dom) {
        // 修复zoom
        if (window.navigator.userAgent.indexOf('Chrome') > 0) {
          dom.style.zoom = 1 / window.scale || 1
        }
        // mxgraph
        this.editor = new ApisEditor({
          el: this.$refs.apisCanvas,
          bars: this.$refs.shapeItem,
          shapes: this.shapes,
          selectedCellListener: function(sender, evt) {
            self.onSelectedCell(sender, evt)
          }
        })
      }
    },
    onSelectedCell(cell) {
      // console.log('value、index、data=', cell)
      if (isEmpty(cell.value) && isEmpty(cell.index)) return
      switch (cell.value) {
        case 'table':
          this.tableItem = isEmpty(cell.data)
            ? {
              apisTbCtls: {
                ctlsName: cell.title
              },
              apisTbCtlsCorrelationList: [],
              apisTbCtlsReqParamList: [],
              apisTbCtlsReqParamConditionsModelList: [],
              apisTbCtlsReturnList: []
            }
            : JSON.parse(cell.data) // this.data.apisTbCtlsModels[cell.index]
          break
        case 'http':
          this.httpItem = isEmpty(cell.data)
            ? {
              apisHttpCtls: {
                ctlsName: cell.title,
                reqMethod: 'GET',
                contentType: 'application/json',
                characterSet: 'utf-8',
                timeOut: 5000
              },
              apisHttpCtlsReqParamList: []
            }
            : JSON.parse(cell.data) // this.data.apisHttpCtlsModels[cell.index]
          break
        case 'constant':
          this.constantItem = isEmpty(cell.data)
            ? {
              apisConstantCvsCtls: {
                ctlsName: cell.title
              },
              apisConstantCvsCtlsDataList: []
            }
            : JSON.parse(cell.data) // this.data.apisConstantCvsCtlsModels[cell.index]
          break
        case 'data':
          this.dataProcessItem = isEmpty(cell.data)
            ? {
              apisDataProcessingCtls: { ctlsName: cell.title },
              apisDataProcessingCtlsDetailList: []
            }
            : JSON.parse(cell.data) // this.data.apisDataProcessingCtlsModels[cell.index]
          break
        case 'respons':
          this.data.apisMainOutCtlsModels = isEmpty(cell.data)
            ? {
              apisMainOutCtls: { ctlsName: cell.title },
              apisMainOutCtlsDataList: []
            }
            : JSON.parse(cell.data) // this.data.apisMainOutCtlsModels
          break
      }
      this.selectCell = cell
      this.dialog[cell.value] = true
    },
    getMethod(methodName) {
      if (isEmpty(methodName)) return
      this[methodName]()
    },
    undoCell() {
      this.editor.execute('undo')
    },
    redoCell() {
      this.editor.execute('redo')
    },
    deleteCell() {
      let self = this
      let cell = this.editor.getSelectedCell()
      let title = cell.title || ''
      if (cell.value === 'begin') return

      if (cell.vertex) {
        this.$confirm(
          '是否删除' + title + ', 删除后配置的数据将会丢失，是否继续?',
          '确认删除',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
          .then(() => {
            if (cell.vertex) {
              switch (cell.value) {
                case 'table':
                  cell.name && self.data.apisTbCtlsModels.splice(cell.index, 1)
                  break
                case 'http':
                  cell.name &&
                    self.data.apisHttpCtlsModels.splice(cell.index, 1)
                  break
                case 'constant':
                  cell.name &&
                    self.data.apisConstantCvsCtlsModels.splice(cell.index, 1)
                  break
                case 'data':
                  cell.name &&
                    self.data.apisDataProcessingCtlsModels.splice(cell.index, 1)
                  break
              }
            }
            self.editor.deleteSelectCells()
            // 更新index
            cell.vertex && self.editor.setIndex(cell.value, cell.index)
          })
          .catch(() => {
            // 暂无操作
          })
      } else {
        self.editor.deleteSelectCells()
      }
    },
    getCell() {
      this.data.apisMainConfig.xml = this.editor.getXML()
      this.dialog.xml = this.data.apisMainConfig.xml
      this.dialog.title = 'XML切换'
      this.dialog.action = null
      this.dialog.showXML = true
    },
    importCell() {
      this.dialog.xml = ''
      this.dialog.title = 'XML导入'
      this.dialog.action = 'import'
      this.dialog.showXML = true
    },
    importXML() {
      if (isEmpty(this.dialog.xml)) {
        this.$message.error('请输入符合mxGraph规范的xml！')
        return
      }
      this.data.apisMainConfig.xml = this.dialog.xml
      this.editor.setXML(this.data.apisMainConfig.xml)
      if (this.dialog.action === 'import') this.updateXML()
      this.dialog.showXML = false
    },
    updateXML() {
      // 思路: 替换xml的控件id、data里面的控件Id、id，更新xml
      let cellList = this.editor.getAllCell()
      this.data.apisTbCtlsModels = []
      this.data.apisHttpCtlsModels = []
      this.data.apisConstantCvsCtlsModels = []
      this.data.apisDataProcessingCtlsModels = []
      cellList.map((cell) => {
        if (isEmpty(cell.value)) return
        switch (cell.value) {
          case 'begin': {
            if (!isEmpty(cell.data)) {
              let list = JSON.parse(cell.data)
              list.forEach((item) => {
                item.id = null
                item.mainConfigId = null
              })
              this.paramList = list.filter((item) => {
                return item.attribute === 'query'
              })
              this.bodyList = list.filter((item) => {
                return item.attribute === 'body'
              })
              this.cookieList = list.filter((item) => {
                return item.attribute === 'cookie'
              })
              this.headerList = list.filter((item) => {
                return item.attribute === 'header'
              })
            }
            break
          }
          case 'table': {
            cell.id = createId('table')
            if (!isEmpty(cell.data)) {
              let table = JSON.parse(cell.data)
              let data = this.updateTable(table, cell.id)
              this.data.apisTbCtlsModels.push(data)
              cell.data = JSON.stringify(data)
              this.editor.update(cell)
            }
            break
          }
          case 'http': {
            cell.id = createId('http')
            if (!isEmpty(cell.data)) {
              let http = JSON.parse(cell.data)
              let data = this.updateHttp(http, cell.id)
              this.data.apisHttpCtlsModels.push(data)
              cell.data = JSON.stringify(data)
              this.editor.update(cell)
            }
            break
          }
          case 'constant': {
            cell.id = createId('constant')
            if (!isEmpty(cell.data)) {
              let constant = JSON.parse(cell.data)
              let data = this.updateConstant(constant, cell.id)
              this.data.apisConstantCvsCtlsModels.push(data)
              cell.data = JSON.stringify(data)
              this.editor.update(cell)
            }
            break
          }
          case 'data': {
            cell.id = createId('data')
            if (!isEmpty(cell.data)) {
              let dataProcess = JSON.parse(cell.data)
              let data = this.updateDataProcess(dataProcess, cell.id)
              this.data.apisDataProcessingCtlsModels.push(data)
              cell.data = JSON.stringify(data)
              this.editor.update(cell)
            }
            break
          }
          case 'respons': {
            cell.id = createId('respons')
            if (!isEmpty(cell.data)) {
              let respons = JSON.parse(cell.data)
              let data = this.updateRespons(respons, cell.id)
              this.$set(this.data, 'apisMainOutCtlsModels', data)
              cell.data = JSON.stringify(data)
              this.editor.update(cell)
            }
            break
          }
        }
      })
      // console.log('importXML', cellList, this.data)
    },
    // table控件
    updateTable(table, newTableId) {
      table.apisTbCtls.id = newTableId
      table.apisTbCtlsReturnList.forEach((item) => {
        item.id = createId()
        item.tbCtlsId = newTableId
      })
      table.apisTbCtlsCorrelationList.forEach((item) => {
        item.id = createId()
        item.tbCtlsId = newTableId
      })
      table.apisTbCtlsReqParamConditionsModelList =
        deepEditReqParamConditionsModels(
          table.apisTbCtlsReqParamConditionsModelList,
          null
        )
      // 递归函数
      function deepEditReqParamConditionsModels(list = [], pid) {
        list.forEach((item) => {
          item.id = createId()
          item.pid = pid
          item.tbCtlsId = newTableId
          if (!isEmpty(item.apisTbCtlsReqParam)) {
            item.apisTbCtlsReqParam.id = createId()
            item.apisTbCtlsReqParam.tbCtlsId = newTableId
          }
          if (!isEmpty(item.reqParamConditionsModels)) {
            item.reqParamConditionsModels = deepEditReqParamConditionsModels(
              item.reqParamConditionsModels,
              item.id
            )
          }
        })
        return list
      }

      return table
    },
    // rest服务控件
    updateHttp(http, newHttpId) {
      http.apisHttpCtls.id = newHttpId
      http.apisHttpCtlsReqParamList.forEach((item) => {
        item.id = createId()
        item.httpCtlsId = newHttpId
      })
      return http
    },
    // 常量转换
    updateConstant(constant, newConstantId) {
      constant.apisConstantCvsCtls.id = newConstantId
      constant.apisConstantCvsCtlsDataList.forEach((item) => {
        item.id = createId()
        item.constantCvsCtlsId = newConstantId
      })
      return constant
    },
    // 数据加工
    updateDataProcess(dataProcess, newDataProcessId) {
      dataProcess.apisDataProcessingCtls.id = newDataProcessId
      dataProcess.apisDataProcessingCtlsDetailList.forEach((item) => {
        item.id = createId()
        item.dataProcessingCtlsId = newDataProcessId
      })
      return dataProcess
    },
    // 输出控件
    updateRespons(respons, newResponsId) {
      respons.apisMainOutCtls.id = newResponsId
      respons.apisMainOutCtlsDataList.forEach((item) => {
        item.id = createId()
        item.mainOutCtlsId = newResponsId
      })
      return respons
    },
    // 参数、body、cookie、header数据更新
    onUpdateList(type, list) {
      switch (type) {
        case 'query':
          this.paramList = list
          break
        case 'body':
          this.bodyList = list
          break
        case 'cookie':
          this.cookieList = list
          break
        case 'header':
          this.headerList = list
          break
        default:
      }
      let apisMainConfigReqCtls = getArrayByConcat(
        this.paramList,
        this.bodyList,
        this.cookieList,
        this.headerList
      )
      this.$set(this.data, 'apisMainConfigReqCtls', apisMainConfigReqCtls)
    },
    onSetPage() {
      let isPage = this.data.apisTbCtlsModels.some((item) => {
        return item.apisTbCtls.isPaging === 1
      })
      let isPageNum = this.paramList.some((item) => {
        return item.param === 'pageNum'
      })
      let isPageSize = this.paramList.some((item) => {
        return item.param === 'pageSize'
      })
      // console.log('分页、pageNum==', isPage, isPageNum)
      if (isPage && !isPageNum) {
        this.paramList.push({
          mainConfigId: null,
          attribute: 'query',
          tenantId: null,
          param: 'pageNum',
          filedType: 'int',
          defValue: 1,
          remark: null
        })
      }

      if (isPage && !isPageSize) {
        this.paramList.push({
          mainConfigId: null,
          attribute: 'query',
          tenantId: null,
          param: 'pageSize',
          filedType: 'int',
          defValue: 10,
          remark: null
        })
      }
    },
    // 更新控件数据
    onUpdateData(type, data) {
      // console.log(
      //   '更新类型、index、数据====',
      //   type,
      //   this.selectCell.index,
      //   data
      // )
      switch (type) {
        case 'table':
          this.updateCell(
            data.apisTbCtls.ctlsName,
            data.apisTbCtls.variableOutTb,
            data
          )
          this.$set(this.data.apisTbCtlsModels, this.selectCell.index, data)
          // 分页设置必须在this.data更新后，才能进行操作
          this.onSetPage()
          break
        case 'http':
          this.updateCell(
            data.apisHttpCtls.ctlsName,
            data.apisHttpCtls.variableOutRest,
            data
          )
          this.$set(this.data.apisHttpCtlsModels, this.selectCell.index, data)
          break
        case 'constant':
          this.updateCell(
            data.apisConstantCvsCtls.ctlsName,
            data.apisConstantCvsCtls.variableSource,
            data
          )
          this.$set(
            this.data.apisConstantCvsCtlsModels,
            this.selectCell.index,
            data
          )
          break
        case 'data':
          this.updateCell(
            data.apisDataProcessingCtls.ctlsName,
            data.apisDataProcessingCtls.variableInData,
            data
          )
          this.$set(
            this.data.apisDataProcessingCtlsModels,
            this.selectCell.index,
            data
          )
          break
        case 'respons':
          this.updateCell(data.apisMainOutCtls.ctlsName, null, data)
          this.$set(this.data, 'apisMainOutCtlsModels', data)
          break
      }
      this.selectCell = null
    },
    // 更新画布控件
    updateCell(title, name, data = {}) {
      if (!isEmpty(title)) this.selectCell.title = title
      this.selectCell.name = name
      this.selectCell.data = JSON.stringify(data)
      this.editor.update(this.selectCell)
    },
    onSave() {
      let mainConfigId = !isEmpty(this.id) ? this.id : createId('apis')
      let cell = this.editor.valid()
      let lines = this.editor.getLine()
      let cellList = this.editor.getAllCell()
      // xml验证
      if (!isEmpty(cell)) {
        this.$message.error(cell.source.title + '控件指向下级控件连线未闭合！')
        return
      }
      // 基本信息
      if (
        isEmpty(this.data.apisMainConfig.name) ||
        isEmpty(this.data.apisMainConfig.serveClass) ||
        isEmpty(this.data.apisMainConfig.reqMethod)
      ) {
        this.$message.error('基本信息名称、分类、请求方式不能为空！')
        return
      }
      this.data.apisMainConfig.id = mainConfigId
      // 线处理
      if (!isEmpty(lines)) {
        lines.forEach((item) => {
          item.id = createId('edge')
          item.mainConfigId = mainConfigId
          item.tenantId = this.tenantId
        })
        this.data.apisLineCtls = lines
      }
      // 参数、body、cookie、header合并
      this.data.apisMainConfigReqCtls = []
      this.data.apisMainConfigReqCtls = getArrayByConcat(
        this.paramList,
        this.bodyList,
        this.cookieList,
        this.headerList
      )
      this.data.apisMainConfigReqCtls.forEach((item) => {
        item.mainConfigId = mainConfigId
      })
      // 将参数储存在begin控件中
      if (!isEmpty(this.data.apisMainConfigReqCtls)) {
        const bcell =
          cellList.filter((item) => {
            return item.value === 'begin'
          })[0] || {}
        bcell.data = JSON.stringify(this.data.apisMainConfigReqCtls)
        this.editor.update(bcell)
      }
      this.data.apisMainConfig.xml = this.editor.getXML()
      // appId
      if (!isEmpty(this.appId)) {
        this.data.apisMainConfig.appId = this.appId
      }

      console.log('save===', this.data)
      // return
      this.saveLoading = true
      this.$http
        .post('/apis/main-config', this.data)
        .then((res) => {
          if (res.code === 200) {
            this.saveLoading = false
            this.$message({
              message: res.msg,
              type: 'success'
            })
            this.$router.push({
              path:
                this.microOpen === 'true'
                  ? '/microApp/apis'
                  : '/apisManage/index',
              query: {
                appId: this.appId,
                microOpen: this.microOpen
              }
            })
          }
        })
        .catch((err) => {
          this.saveLoading = false
          this.$message.error(err.msg)
        })
    },
    onCancel() {
      this.$confirm(
        '之前的操作尚未保存, 取消后数据将会丢失，是否继续?',
        '确认取消',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          this.$router.push({
            path:
              this.microOpen === 'true'
                ? '/microApp/apis'
                : '/apisManage/index',
            query: {
              appId: this.appId,
              microOpen: this.microOpen
            }
          })
        })
        .catch(() => {
          // 暂无操作
        })
    }
  },
  created() {
    this.loadData()
    this.loadAllDbs()
    this.loadConst()
    this.loadApp()
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  }
}
</script>
<style lang='scss' scoped>
@import '../styles/index.scss';
</style>
